// src/components/Logout.jsx
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Logout() {
  const [loading, setLoading] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      setLoading(true);
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <button 
      onClick={handleLogout}
      className="logout-button"
      disabled={loading}
    >
      {loading ? 'Cerrando...' : 'Cerrar sesión'}
    </button>
  );
}